import React from 'react'
import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers/components/KTIcon'
import {Spinner} from 'react-bootstrap'

interface SearchResult {
  pageId: string
  title: string
  shortDescription: string
  category: string
  icon: string
  matchSnippet: string
}

interface Props {
  results: SearchResult[]
  query: string
  isLoading: boolean
}

const HelpSearchResults: React.FC<Props> = ({results, query, isLoading}) => {
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className='text-center py-10'>
        <Spinner animation='border' variant='primary' size='sm' />
        <p className='text-muted mt-3'>Searching...</p>
      </div>
    )
  }

  if (results.length === 0 && query) {
    return (
      <div className='text-center py-10'>
        <KTIcon iconName='search-list' className='fs-2tx text-gray-400 mb-4 d-block' />
        <h5 className='text-gray-700'>No results found</h5>
        <p className='text-muted'>
          No help articles match "<strong>{query}</strong>". Try a different search term.
        </p>
      </div>
    )
  }

  return (
    <div>
      <p className='text-muted mb-4'>
        Found <strong>{results.length}</strong> result{results.length !== 1 ? 's' : ''} for "
        <strong>{query}</strong>"
      </p>
      {results.map((result) => (
        <div
          key={result.pageId}
          className='card help-search-result mb-3 p-4'
          onClick={() => navigate(`/help/${result.pageId}`)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              navigate(`/help/${result.pageId}`)
            }
          }}
          role='button'
          tabIndex={0}
          aria-label={`${result.title} - ${result.shortDescription}`}
        >
          <div className='d-flex align-items-start gap-3'>
            <div className='flex-shrink-0 mt-1'>
              <KTIcon iconName={(result.icon || 'document').replace(/^ki-/, '')} className='fs-2 text-primary' />
            </div>
            <div className='flex-grow-1'>
              <div className='d-flex align-items-center gap-2 mb-1'>
                <span className='result-title'>{result.title}</span>
                <span className='badge badge-light-primary badge-sm'>{result.category}</span>
              </div>
              <p className='text-muted mb-1 fs-7'>{result.shortDescription}</p>
              {result.matchSnippet && (
                <p className='result-snippet mb-0'>{result.matchSnippet}</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export {HelpSearchResults}
